import * as yup from "yup";
import { validationArraySelect, validationNotEmpty, validationStringSelect } from "./defaultValidations";

export default yup.object({
  policyName: validationStringSelect("Policy Name"),
  plaintext: validationNotEmpty("Plain Text"),
});
